var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: {
        "enter-active-class": "animated slideInLeft",
        "leave-active-class": "animated slideOutRight",
      },
    },
    [
      _vm.value === true
        ? _c(
            "span",
            [
              _vm._t("loading"),
              _vm._v(" "),
              _c("fa", { attrs: { icon: "circle-notch", spin: "" } }),
            ],
            2
          )
        : _c(
            "span",
            [
              _vm._t("default"),
              _vm._v(" "),
              _vm.icon !== null
                ? _c("fa", { attrs: { icon: _vm.icon } })
                : _vm._e(),
            ],
            2
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }